/**
 *  pagingComposition.
 *
 */
import issueActionCreators from '../../actions/issueActionCreators';
import pagingComposition from '../common/pagingTable/pagingComposition';
export default pagingComposition(
// these are specific to issues.
'issue',
// these describe the column to attribute mapping.  this is used for
// sending sorting queries to the server.
issueActionCreators,
// sorting definition
{
  Label: 'label',
  Title: 'title',
  Report: 'reportNumber',
  Severity: 'issueSeverity',
  Status: 'issueStatus',
  Creator: 'lastName',
  Created: 'created'
});